import { createSlice } from '@reduxjs/toolkit'
import { StockFilterParams } from 'constants/configLocalStorage'

const paramsOld = localStorage.getItem(StockFilterParams)
const parseParamsOld = paramsOld ? JSON.parse(paramsOld) : null
if (parseParamsOld) {
  parseParamsOld.page = 0
}

export const StockInvestStore = createSlice({
  name: 'StockInvestStore',
  initialState: {
    StockFilterData: [],
    FilterStockInvest: parseParamsOld ? parseParamsOld : {
      page: 0,
      size: 30,
      growthFilter: '',
      valueFilter: '',
      dscRatingFilter: '',
      momentumFilter: '',
      liquidityFilter: 'desc',
      marCapFilter: '',
    },
  },
  reducers: {
    setStockFilterData: (state: any, actions: any) => {
      state.StockFilterData = actions.payload
    },
    setFilterStockInvest: (state: any, actions: any) => {
      localStorage.setItem(StockFilterParams, JSON.stringify(actions.payload))
      state.FilterStockInvest = actions.payload
    },
  }
})

// Action creators are generated for each case reducer function
export const {
  setStockFilterData,
  setFilterStockInvest
} = StockInvestStore.actions

export default StockInvestStore.reducer